
import { useApiQuery } from './useApiQuery'
import { apiRoutes } from './apiRoutes'
import { PortalOrgUiConfigLink, PortalOrgUiConfigSections, OrderRequestSendToOption } from '../types/portalTypes/PortalDomainOrg'


export interface UserConfigResponse {
  roles: string[];
  uiConfig: {
    Links?: PortalOrgUiConfigLink[];
    Sections?: PortalOrgUiConfigSections;
    OrderRequestSendToOptions?: OrderRequestSendToOption[];
  } | null;
  orderRequestEnabled: boolean;
}

// New hook name to match established pattern (useGetX)
export function useGetUserConfig(options?: { enabled?: boolean }) {
  // Enabled defaults to true for callers who already gated by auth; explicit false disables
  const enabled = options?.enabled ?? true
  const query = useApiQuery<UserConfigResponse>(apiRoutes.getUserConfig(), {
    enabled,
    staleTime: 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 1,
    // Custom select or error handling could go here later
  })
  return query
}

// Backward compatible export; prefer useGetUserConfig going forward.
export const useUserConfig = (enabled: boolean) => useGetUserConfig({ enabled })
